import { z } from "zod";
import { emailSchema } from "../common/index.js";

export const microsoftTokenPayloadSchema = z.object({
	sub: z.string(),
	tid: z.string(),
	oid: z.string().optional(),
	email: emailSchema.optional(),
	preferred_username: z.string().optional(),
	name: z.string().optional(),
	given_name: z.string().optional(),
	family_name: z.string().optional(),
});

export type MicrosoftTokenPayload = z.infer<typeof microsoftTokenPayloadSchema>;
